// src/pages/Builders/ProjectInvite.jsx
import React, { useState } from "react"; // Import useState
import Layout from "../../layout/builders/Layout";
import ProjectInviteForm from "../../layout/builders/ProjectInvite/ProjectInviteForm";
import ProjectBanner from "../../layout/builders/ProjectBanner";
import PendingApprovalTable from "../../layout/builders/ProjectInvite/PendingApprovalTable"; // Import the new table

const ProjectInvite = () => {
  const [activeTab, setActiveTab] = useState('send'); // 'send' or 'pending'

  return (
    <div style={{ backgroundColor: "#E0E0E0" }}>
      <Layout>
        {/* Banner can remain generic or be updated if needed */}
        <div>
          <ProjectBanner
            title="Project Invite Management" // Updated title
            imageUrl="https://via.placeholder.com/1200x300"
          />
        </div>

        {/* Tab Navigation */}
        <div className="mb-4 border-b border-gray-300">
          <nav className="-mb-px flex space-x-6" aria-label="Tabs">
            <button
              onClick={() => setActiveTab('send')}
              className={`whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                activeTab === 'send'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Send Invite
            </button>
            <button
              onClick={() => setActiveTab('pending')}
              className={`whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                activeTab === 'pending'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Pending Invites for Approval
            </button>
          </nav>
        </div>

        {/* Conditional Content */}
        <div>
          {activeTab === 'send' && <ProjectInviteForm />}
          {activeTab === 'pending' && <PendingApprovalTable />}
        </div>
      </Layout>
    </div>
  );
};

export default ProjectInvite;